import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={20}
    height={23}
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.20669 6.94498H7.66243C7.41299 6.94498 7.20896 7.14903 7.20896 7.39846V7.98799H6.05253C5.37222 7.98799 4.82812 8.53224 4.82812 9.21239V15.9017C4.82812 16.582 5.37238 17.1261 6.05253 17.1261H13.921C14.6013 17.1261 15.1454 16.5819 15.1454 15.9017V9.21239C15.1454 8.53208 14.6012 7.98799 13.921 7.98799H12.7646V7.39846C12.7646 7.14902 12.5605 6.94498 12.3111 6.94498H11.7669C11.5174 6.94498 11.3134 7.14903 11.3134 7.39846V7.98799L8.6602 7.98783V7.3983C8.6602 7.14886 8.45616 6.94482 8.20673 6.94482L8.20669 6.94498ZM14.2838 10.6864V15.9018C14.2838 16.1059 14.125 16.2647 13.9209 16.2647H6.05246C5.84841 16.2647 5.68961 16.1059 5.68961 15.9018V10.6864H14.2838Z"
      fill="#666666"
    />
    <path
      d="M11.9942 13.1122H13.1732C13.332 13.1122 13.4681 12.9762 13.4681 12.8174V11.933C13.4681 11.7742 13.332 11.6382 13.1732 11.6382H11.9941C11.8352 11.6382 11.6992 11.7742 11.6992 11.933V12.8174C11.722 12.976 11.8354 13.1122 11.9942 13.1122Z"
      fill="#666666"
    />
    <path
      d="M9.41202 13.1122H10.5912C10.75 13.1122 10.886 12.9762 10.886 12.8174V11.933C10.886 11.7742 10.75 11.6382 10.5912 11.6382H9.41202C9.25321 11.6382 9.11719 11.7742 9.11719 11.933V12.8174C9.11719 12.976 9.25322 13.1122 9.41202 13.1122Z"
      fill="#666666"
    />
    <path
      d="M6.80184 13.1122H7.95839C8.11719 13.1122 8.25322 12.9762 8.25322 12.8174V11.933C8.25322 11.7742 8.11719 11.6382 7.95839 11.6382H6.77921C6.6204 11.6382 6.48438 11.7742 6.48438 11.933V12.8174C6.50715 12.976 6.64318 13.1122 6.80183 13.1122H6.80184Z"
      fill="#666666"
    />
    <path
      d="M11.9942 15.4481H13.1732C13.332 15.4481 13.4681 15.3121 13.4681 15.1533V14.269C13.4681 14.1101 13.332 13.9741 13.1732 13.9741H11.9941C11.8352 13.9741 11.6992 14.1102 11.6992 14.269V15.1533C11.722 15.312 11.8354 15.4481 11.9942 15.4481Z"
      fill="#666666"
    />
    <path
      d="M9.41202 15.4481H10.5912C10.75 15.4481 10.886 15.3121 10.886 15.1533V14.269C10.886 14.1101 10.75 13.9741 10.5912 13.9741H9.41202C9.25321 13.9741 9.11719 14.1102 9.11719 14.269V15.1533C9.11719 15.312 9.25322 15.4481 9.41202 15.4481Z"
      fill="#666666"
    />
    <path
      d="M6.80184 15.4481H7.95839C8.11719 15.4481 8.25322 15.3121 8.25322 15.1533V14.269C8.25322 14.1101 8.11719 13.9741 7.95839 13.9741H6.77921C6.6204 13.9741 6.48438 14.1102 6.48438 14.269V15.1533C6.50715 15.312 6.64318 15.4481 6.80183 15.4481H6.80184Z"
      fill="#666666"
    />
    <path
      d="M10.2947 2.31864V1.27564C10.2947 0.844761 9.84127 0.595327 9.47842 0.799369L6.62132 2.50005C6.25847 2.70409 6.25847 3.22575 6.62132 3.42979L9.47842 5.15311C9.84127 5.37993 10.2947 5.10771 10.2947 4.67684V3.67907C14.9206 3.83787 18.6167 7.62469 18.6167 12.2732C18.6167 17.0351 14.7391 20.89 9.99996 20.89C5.23806 20.89 1.38318 17.0123 1.38318 12.2732C1.38318 9.46134 2.7664 6.83099 5.05661 5.22102C5.37407 4.99419 5.44208 4.5861 5.21542 4.26864C4.9886 3.95118 4.5805 3.88317 4.26304 4.10983C1.60998 5.96932 0 9.03046 0 12.2731C0 17.7833 4.4898 22.2731 10 22.2731C15.5102 22.2731 20 17.7833 20 12.2731C20 6.87627 15.6689 2.47717 10.2948 2.31844L10.2947 2.31864Z"
      fill="#666666"
    />
  </svg>
);
export default SVGComponent;
